import Login from './Login';
// import Signup from './Signup';

export default {
  Login,
  // Signup,
};
